module.exports = __webpack_public_path__ + "img/Fish.be013ef2.jpg";